import axiosInstance from './axiosInstance';

const projectsService = {
  editProject: async (project) => {
    try {
      const response = await axiosInstance.post('/projects/edit', project);
      return response.data;
    } catch (error) {
      console.error('Error creating project:', error.response?.data || error.message);
      throw error;
    }
  },
  getExistingProjects: async () => {
    try {
      const response = await axiosInstance.post('/projects/existing-projects', {});
      return response.data.projects;
    } catch (error) {
      console.error('Error fetching goal:', error.response?.data || error.message);
      throw error;
    }
  },
  updateProject: async (fields) => {
    try {
      const response = await axiosInstance.post('/projects/update-project', fields);
      return response.data.projects;
    } catch (error) {
      console.error('Error fetching goal:', error.response?.data || error.message);
      throw error;
    }
  },
};

export default projectsService;
